import { render, staticRenderFns } from "./404PagesPage.vue?vue&type=template&id=ebb25e64&"
import script from "./404PagesPage.vue?vue&type=script&lang=js&"
export * from "./404PagesPage.vue?vue&type=script&lang=js&"
import style0 from "./404PagesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "404PagesPage.vue"
export default component.exports